/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import React, {useEffect} from "react"
import {useOktaAuth} from "@okta/okta-react"
import {toRelativeUrl} from "@okta/okta-auth-js"
import {datadogLogs} from "@datadog/browser-logs"
import {Outlet} from "react-router-dom"

export const RequiredAuth = () => {
	const {oktaAuth, authState} = useOktaAuth()

	useEffect(() => {
		if (!authState) {
			return
		}

		if (!authState.isAuthenticated) {
			const originalUri = toRelativeUrl(window.location.href, window.location.origin)
			oktaAuth.setOriginalUri(originalUri)
			oktaAuth.signInWithRedirect().catch((reason) => {
				datadogLogs.logger.error("Convert Metrics okta sign in failed", reason)
				throw reason
			})
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [oktaAuth, !!authState, authState?.isAuthenticated])

	if (!authState || !authState.isAuthenticated) {
		return <h1>Loading...</h1>
	}

	return <Outlet />
}
